/**
 * Shared style tokens for the editorial content pages (resurse, condition
 * pages, method pages) and the Sanity-driven TopicPage template.
 *
 * These exist because the ~27 hand-built content pages were copy-pasted from
 * each other and had started to drift: five different eyebrow pills, four
 * heading sizes, two FAQ accordions. Anything new in this family should pull
 * its type and buttons from here rather than inventing another variant.
 *
 * The language matches the homepage and /sesiune-cunoastere: serif display
 * type, hairline rules instead of card shadows, flat buttons, one accent.
 */

export const eyebrowClass =
  "text-xs font-semibold uppercase tracking-[0.3em] text-[#2C969B]";

export const h1Class =
  "font-serif text-[clamp(2rem,4.6vw,3.5rem)] font-normal leading-[1.08] tracking-[-0.015em] text-[#264653]";

export const h2Class =
  "font-serif text-[clamp(1.6rem,3.4vw,2.6rem)] font-medium leading-[1.12] tracking-[-0.015em] text-[#264653]";

export const leadClass =
  "text-[16px] leading-relaxed text-[#264653]/70 sm:text-[17px]";

export const btnPrimary =
  "inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-[#DC7050] px-7 text-[15px] font-semibold text-white transition-colors hover:bg-[#c25c3e]";

export const btnGhost =
  "inline-flex h-12 items-center justify-center gap-2 rounded-lg border border-[#264653]/20 px-7 text-[15px] font-semibold text-[#264653] transition-colors hover:border-[#264653]/45";

/** Hairline rule between sections, with the standard vertical rhythm. */
export const sectionClass = "border-t border-[#264653]/10 py-16 sm:py-24";
